import React from "react";
import AlertComponent from "~/components/AlertComponent";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import FolderCard from "../../../components/FolderCard";
import { formatCentsToRealStr }  from "../../../helpers/monetary"

const FoldersComponent = ({
  images,
  onClick,
  onDelete,
  onDownload,
  onView,
  handleOnDragEnd
}) => {
  return (
    <>  
      <div className="content content-xs">
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="images">
            {(provided) => (
              <ul {...provided.droppableProps} ref={provided.innerRef} style={{padding: "0px"}}> 
                {images?.map((item, index) => {
                  return (       
                    <Draggable key={item.imageId.toString()} draggableId={item.imageId.toString()} index={index}>
                      {(provided) => (
                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                          <FolderCard     
                            productCode={item.product?.code}
                            productName={((item.product?.description !== null && item.product?.description !== "") ?  item.product?.description : item.product?.name)}
                            productValue={'R$ '.concat(formatCentsToRealStr(item.product?.value))}
                            highlightType={item.highlightType}
                            originalValue={'R$ '.concat(formatCentsToRealStr(item.product?.originalValue))}
                            clubValue={'R$ '.concat(formatCentsToRealStr(item.product?.clubValue))}
                            pageDescription={item.pageDescription}
                            index={index}
                            onClick={() => {
                              onClick(item.imageId);
                            }}
                            onDelete={() => {
                              AlertComponent.dialog("Irá apagar o informativo.",
                                function dialoagNo() {
                                },
                                function dialoagYes() {
                                  onDelete(item.imageId);
                                }    
                              );
                            }}
                            onView={() => {
                              onView(item);
                            }}
                            onDownload={() => {
                              onDownload(item);
                            }}
                          />
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>        
      </div>
    </>
  );
};

export default FoldersComponent;
